import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import PermissionDeniedPage from "../components/PermissionDeniedPage";

export default function PageWithPermission({
  permissionKey,
  children,
}: {
  permissionKey: string;
  children?: any;
}) {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem("access_token");
  const permissions = useSelector((state: any) => state.permissions);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const hasAccess = permissionKey ? permissions[permissionKey] : false;

  if (hasAccess) return children;
  return <PermissionDeniedPage />;
}
